module.exports = __webpack_public_path__ + "static/mailgun-7ede86a18f51ab5ca7dd91b52da8b538.png";